import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class GetVipRoomOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderquery/getVipRoomOrderDetail'
		this.desc = '获取贵宾休息室订单详细信息'
	}
}

export class GetQueueServiceOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderquery/getQueueServiceOrderDetail'
		this.desc = '获取一条龙订单详细信息'
	}
}

export class QueryBatteryOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/batteryCar/queryBatteryOrderDetail'
		this.desc = '查询电瓶车订单'
	}
}

export class BatteryCarRefund extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/batteryCar/booking/refund'
		this.desc = '查询电瓶车订单'
	}
}

export class GetStopWayOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderquery/getStopWayOrderDetail'
		this.desc = '获取stopWay订单详细信息'
	}
}

export class OrderCancel extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/order/orderCancel'
		this.desc = '取消订单接口'
	}
}

export class OpenOrderInvoice extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/order/openOrderInvoice'
		this.desc = '订单开发票'
	}
}

export class ReOpenOrderInvoice extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/order/reOpenOrderInvoice'
		this.desc = '订单重新开发票'
	}
}

export class GetAvailableRefundInfo extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderRefund/getAvailableRefundInfo'
		this.desc = '获取订单可退信息'
	}
}

export class FastRefund extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderRefund/fastRefund'
		this.desc = '快速退款'
	}
}

export class CancelRefundStopWay extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderRefund/cancelRefundStopWay'
		this.desc = '取消订单并退款'
	}
}

export class EquityPackageOrderRefund extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderRefund/equityPackageOrderRefund'
		this.desc = '权益包订单退款'
	}
}

export class GetOverTimeByFlow extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderStopWayFlow/getOverTimeByFlow'
		this.desc = '获取超时费'
	}

	dataformat(json) {
		return json
	}
}

export class GetStopWayRefundInfo extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/orderRefund/getStopWayRefundInfo'
		this.desc = '获取退款信息'
	}
}

export class StopWayUpdateReserveTime extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/stopWayUpdateReserveTime'
		this.desc = '更改stopWay入场时间'
	}
}

export class RightsOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/equityOrder/query/detail'
		this.desc = '获取权益订单订单详细信息'
	}
}

export class MyRightsOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/equityOrder/query/snapshot/resource/detail'
		this.desc = '获取权益订单产品资源快照信息'
	}
}

export class QueryProductsById extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.ORDER
		this.url = '/equityOrder/query/snapshot/resource/items'
		this.desc = '获取权益订单产品资源对应的适用范围信息(产品结合/其他类集合等)'
	}
}

export class AddReserveRecord extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/reserveRecords/AddReserveRecord'
		this.desc = '预约安检'
	}
}

export class GetReserveRecordsById extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/orderquery/getReserveRecordsById'
		this.desc = '根据ID查询预约详情'
	}
}

export class AbroadOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/outbound/query/detail'
		this.desc = '获取出入境服务订单详细信息'
	}
}

export class AbroadBookingSuccessDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/outbound/query/booking/detail'
		this.desc = '获取出入境服务订单-- 预订第三方信息'
	}
}

export class AbroadRefundInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/outbound/check/refund'
		this.desc = '检查出入境服务产品退款信息'
	}
}

export class AbroadRefund extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/outbound/refund'
		this.desc = '出入境服务订单退款'
	}
}

export class GetStopWayOverTimeOrderDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/orderquery/getStopWayOverTimeOrderDetail'
		this.desc = '获取stopWay超时费订单详细信息'
	}
}

export class QueryParkingRecordList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/orderquery/queryParkingRecordList'
		this.desc = '根据条件查询用户停车记录信息'
	}

	dataformat(data) {
		super.dataformat(data)

		const { list = [], pages = 0, pageIndex = 1, pageTotal = 0 } = data.resultData || {}

		return {
			list,
			pages,
			pageIndex,
			total: pageTotal,
		}
	}
}

export class ShortUrlOrderDetails extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/orderquery/shortUrlOrderDetails'
		this.desc = '短链接订单信息接口'
	}
}

export class CodeRefresh extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/orderbase/vip/voucher/refresh'
		this.desc = '验证码实时刷新 伊斯坦布尔用'
	}

	dataformat(json) {
		// super.dataformat(json)
		return json
	}
}

export class CreatePayOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/orderbase/createPayOrder'
		this.desc = '创建支付请求单'
	}
}

export class GetVipOrderStatus extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/orderquery/getVipOrderStatus'
		this.desc = '获取贵宾订单状态'
	}
}

export class GetLessonList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/seedLesson/getLessonList'
		this.desc = '获取孵化课程列表'
	}

	dataformat(json) {
		super.dataformat(json)

		return (json.resultData || {}).lessonList
	}
}

export class BookingLesson extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/seedLesson/bookingLesson'
		this.desc = '孵化课程购买'
	}

	dataformat(json) {
		super.dataformat(json)
		return (json || {}).resultData
	}
}

export class UserDelOrder extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/orderbase/userDelOrder'
		this.desc = '用户删除订单'
	}
}

/** 行李管家 start */
export class QueryLogistics extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/luggage/v2/query/logistics'
		this.desc = '获取行李管家物流信息'
	}

	dataformat(json) {
		super.dataformat(json)
		return json.resultData || [{}]
		/*return [
            {
                courier: '邱杰杰',
                courierMobile: '15502858542',
                logisticsCompany: '顺丰速运',
                logisticsNo: 'SF982312938120283',
                logisticsStatusName: '配送中',
                nodes: [
                    {
                        statusMessage: '您的快件已签收，签收人是[服务点签收]',
                        time: '2020.09.23 19:30:05',
                    },
                    {
                        statusMessage: '您的快件已签收，签收人是[服务点签收]',
                        time: '2020.09.23 19:30:05',
                    },
                    {
                        statusMessage: '您的快件已签收，签收人是[服务点签收]',
                        time: '2020.09.23 19:30:05',
                    },
                    {
                        statusMessage: '您的快件已签收，签收人是[服务点签收]',
                        time: '2020.09.23 19:30:05',
                    },
                ],
            },
        ]*/
	}
}

export class LuggageDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/luggage/v2/query/detail'
		this.desc = '查询订单详情'
	}

	dataformat(json) {
		super.dataformat(json)
		return (json || {}).resultData
	}
}

export class LuggageLogistics extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/luggage/v2/query/logistics'
		this.desc = '获取行李管家物流信息'
	}

	dataformat(json) {
		super.dataformat(json)
		return (json || {}).resultData
	}
}

export class LuggageOrderStatus extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/luggage/v2/getOrderStatus'
		this.desc = '获取行李管家订单状态'
	}

	dataformat(json) {
		super.dataformat(json)
		return (json || {}).resultData
	}
}

export class LuggageRefund extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/luggage/v2/check/refund'
		this.desc = '获取行李管家物流信息'
	}

	dataformat(json) {
		super.dataformat(json)
		return (json || {}).resultData
	}
}

export class LuggageV2Refund extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/luggage/v2/refund'
		this.desc = '获取行李管家物流信息'
	}

	dataformat(json) {
		super.dataformat(json)
		return (json || {}).resultData
	}
}

export class LuggageAddImages extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.ORDER
		this.url = '/order/luggage/v2/addImages'
		this.desc = '行李管家订单图片补充'
	}
}
/** 行李管家 end */
